import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Бүртгэлгүй этгээд")
const _hoisted_5 = { class: "row g-10" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "card shadow mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "УБЕГ-т бүртгэлгүй хэрэглэгчид нэмэх")
  ])
], -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = ["data-kt-indicator"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fs-8" }),
  /*#__PURE__*/_createTextVNode(" Нэмэх ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "card card-stretch shadow mb-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Сүүлд бүртгэгдсэн регистр")
  ])
], -1)
const _hoisted_17 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                model: this.modalform,
                ref: "adduncheckregister",
                "label-width": "120px",
                "label-position": "right",
                rules: _ctx.modalformrules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "registerno",
                    label: "Нэмэх регистр:",
                    size: "mini",
                    "label-width": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: this.modalform.registerno,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.modalform.registerno) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createElementVNode("button", {
                class: "el-button el-button--default el-button--small is-plain",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit())),
                ref: "submitButton",
                style: {"float":"right"},
                "data-kt-indicator": this.addbuttonloader
              }, _hoisted_13, 8, _hoisted_10),
              _createVNode(_component_el_button, {
                ref: "submitHideButton",
                size: "mini",
                hidden: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRegister()))
              }, null, 512)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.pageSize,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageSize) = $event)),
                onChange: _ctx.handleChange,
                style: {"width":"100px","float":"left"},
                min: 1,
                max: 100,
                size: "mini"
              }, null, 8, ["modelValue", "onChange"]),
              _createVNode(_component_el_input, {
                "prefix-icon": "el-icon-search",
                modelValue: _ctx.customerSearch,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerSearch) = $event)),
                size: "mini",
                placeholder: "Хайх утга аа оруулна уу...",
                style: {"float":"right","width":"35%"}
              }, null, 8, ["modelValue"])
            ]),
            true
              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: 
                this.tableData
                  .filter(
                    data =>
                      !this.customerSearch ||
                      data.registerno
                        .toLowerCase()
                        .includes(this.customerSearch.toLowerCase())
                  )
                  .slice(
                    this.pageSize * this.page - this.pageSize,
                    this.pageSize * this.page
                  )
              ,
                  style: {"width":"100%","margin-top":"50px"},
                  border: "",
                  size: "mini",
                  "element-loading-text": "Өгөгдөл татаж байна...",
                  "empty-text": "Өгөгдөл байхгүй байна.",
                  "cell-style": { textAlign: 'center' },
                  "header-cell-style": { textAlign: 'center' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "№",
                      width: "40"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Регистр",
                      prop: "registerno",
                      sortable: ""
                    })
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, _ctx.loadingTable]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}